export const PAYSTACK_PUBLIC_KEY = 'pk_test_1bd3d130cbb6f84a90e8cdb0e13a82a659ebbedc'
export const FLUTTERWAVE_PUBLIC_KEY = 'FLWPUBK_TEST-b7eb58ee9768abf02faebf8420d803b5-X'
